import { EmptyState } from "@quortex/front-common"
import { isEmpty } from "lodash-es"
import type { FC } from "react"
import illustrationNoOttEndpoints from "src/App/play/images/illustration-no-ott-endpoints.svg"
import AddOttEndpointButton from "@/App/play/App/Main/Pool/endpoints/ottEndpoints/OttEndpointList/AddOttEndpointButton"
import type { OttEndpointRow } from "@/App/play/App/Main/Pool/endpoints/ottEndpoints/OttEndpointList/types"

type Props = {
  row?: OttEndpointRow
  hasWriteAccess: boolean
}
const OttEndpointWizardEmptyState: FC<Props> = ({ row, hasWriteAccess }) => {
  return (
    <EmptyState
      description=" No OTT endpoint has been configured yet."
      img={illustrationNoOttEndpoints}
    >
      {hasWriteAccess && !!row && isEmpty(row?.endpoints) && (
        <div className="flex items-center justify-center">
          <AddOttEndpointButton row={row} />
        </div>
      )}
    </EmptyState>
  )
}

export default OttEndpointWizardEmptyState
